import { Box } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import React from 'react';
import ReactApexChart from 'react-apexcharts';

export function ComparativeCardLine() {
  const series: ApexOptions['series'] = [
    {
      data: [400, 430, 448, 470],
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 150,
      toolbar: {
        show: false,
      },
      background: '#fff',
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
        barHeight: '40%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      categories: ['Mar', 'Abr', 'Mai', 'Jun'],
    },
    grid: {
      show: false,
    },
  };

  return (
    <Box width="85%">
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={150}
      />
    </Box>
  );
}
